/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Icon = styled.span`
  display: inline-block;
  ${(p) => p.round && 'border-radius: .25rem;'}
  ${(p) => p.circle && 'border-radius: 50%;'}
  ${(p) => (p.round || p.circle) && 'padding: .25rem;'}

  background-color: ${(p) => p.bgColor || 'inherit'};

  line-height: 1;

  &:focus {
    outline: 0;
    box-shadow: 0 0 3px #0070D2;
  }
`;

const SVG = styled.svg`
  height: ${(p) => p.size ? p.size : '1rem'};
  width: ${(p) => p.size ? p.size : '1rem'};
  fill: white;
`;

/**
 * Icon Container for Action SLDS Icons
 */
const ActionIcon = ({ className, onClick, icon, size, bgColor, round, circle }) => (
  <Icon className={className} onClick={onClick} bgColor={bgColor} size={size} round={round} circle={circle}>
    <SVG size={size}>
      <use xlinkHref={`/assets/icons/action-sprite/svg/symbols.svg#${icon}`}></use>
    </SVG>
  </Icon>
);

ActionIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string
};

ActionIcon.defaultProps = {
  show: true,
};

export default ActionIcon;
